export default {
    visitorView: 'ดูผู้เยี่ยมเยือน',
    visitorInfo: 'ข้อมูล',
    citizenIdPassportId: 'บัตรประชาชน / หนังสือเดินทาง',
    visitorName: 'ชื่อ',
    visitorSurname: 'นามสกุล',
    visitorGender: 'เพศ',
    visitAt: 'เยี่ยมที่สำนักงาน',
    emailAddress: 'อีเมล',
    phoneNumber: 'เบอร์โทรศัพท์',
    operator: 'บุคคลที่มาเข้าพบ (รหัสพนักงาน)',
    visitorStatus: 'สถานะ',
    visitorActive: 'ใช้งาน',
    visitorDeactive: 'ปิดใช้งาน',
    activityLog: 'ประวัติกิจกรรม',
    male: 'ชาย',
    female: 'หญิง',
    others: 'อื่นๆ'
}
